import React, { useState, useEffect } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import productService from "../services/product";
import { swalError } from '../utils/swal';
import ProductBox from "./ProductBox";
import constants from "../utils/constants";
import keys from "../store/keys";

function Products({ session, setKey, ...props }) {

	const [rows, setRows] = useState([]);
	const [sortBy, setSortBy] = useState("date-desc");

	useEffect(() => {
		reload();
	}, [session.searchKeyword,
	session.searchCategory,
	session.searchBrands,
	session.searchCategories,
	session.searchPriceMin,
	session.searchPriceMax,
	session.selectedRegion,
	sortBy]);

	const reload = () => {

		let data = {
			keyword: session.searchKeyword,
			category: session.searchCategory,
			brands: session.searchBrands,
			subCategories: session.searchCategories,
			minPrice: session.searchPriceMin ? session.searchPriceMin : constants.minPrice,
			maxPrice: session.searchPriceMax ? session.searchPriceMax : constants.maxPrice,
			currency: session.selectedRegion ? session.selectedRegion.currency : "EUR",
			sortBy: sortBy
		};

		setKey(keys.isLoading, true);
		setRows([]);
		productService.getAll(session.token, data)
			.then(result => {
				if (result.error) {
					swalError(result.error);
					return;
				}
				setRows(result.data);
				setKey(keys.isLoading, false);
			});
	}

	const renderProducts = () => {
		if (!rows || rows.length === 0)
			return (<div>No data found.</div>);

		return rows.map(k => <ProductBox key={k._id} data={k} />)
	}


	return (
		<>
			<div className="row mt-10" style={{ paddingLeft: 35 }}>
				<div className="col-9" style={{ paddingTop: 10 }}>
					<span style={{fontSize: 13, color: "#413F3F"}}>{rows.length} Results</span>
				</div>
				<div className="col-3 text-end" style={{}}>
					<select 
						className="form-control shadow-none" 
						style={{ width: 200, fontSize: 13, color: "#413F3F", background: "#F6F6F6", paddingTop: 5, paddingBottom: 3 }} 
						value={sortBy} 
						onChange={e => setSortBy(e.target.value)}
						>
						<option value="date-desc">New In</option>
						<option value="price-desc">Price High to Low</option>
						<option value="price-asc">Price Low to High</option>
					</select>
				</div>
			</div>
			<div className="row mt-10">
				<div className="col">
					<div className="products">
						{renderProducts()}
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
